export default "__VITE_ASSET__CoS451L___"